import Constant from '../../common/constant/Constant';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { duplicateField } from './handler/FormListHandler';

const {
    IconButton,
    Popover
} = require('@material-ui/core');
const { useState } = require('react');

export default function MoreActionField({argsAll,field,regionDropId}) {
    useTranslationSubscription();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            {(field.type != Constant.FORM_TYPE.FIELD_WORKFLOW) && (
                <IconButton
                    className="itemTools"
                    onClick={handleClick}
                >
                    <img src="/assets/image/icon-nav-manage.svg" alt="" />
                </IconButton>
            )}
            <Popover
                className="nav-addManage"
                id={open ? 'simple-popover' : undefined}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <ul>
                    <li>
                        <span className="item" onClick={(e) => {
                                duplicateField(argsAll, field, regionDropId);
                                setAnchorEl(null);
                                argsAll.setIsChangeData(true);
                            }}>
                            <img src="/assets/image/icon-copy.svg" alt="" />
                        </span>
                        <span className="text">{trI18n('FIELDFORMBTN013')}</span>
                    </li>
                </ul>
            </Popover>
        </>
    );
}
